<template>
    <span class="report-label-annotation-item" 
        :data-type="'report-label-annotation-item'"
        :data-annotation-id="annotation.id" 
        :data-disabled="disabled"
        :data-selected="isSelected" 
        :data-hovered="isHovered" :style="{ '--annotation-color': annotationColor }" @click="onClick" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
        <span class="text">{{ annotation.reportText }}</span>
        <span v-if="detailsText.length > 0" class="details">{{ detailsText }}</span>
    </span>
</template>

<script>
import { evtBus } from '@/main';
import { reportUtils } from '@/features/report/lib/reportUtils';
import LabelAnnotation from '@/features/report/models/LabelAnnotation';

export default {
    name: 'reportLabelAnnotationItem',
    props: {
        annotation: {
            type: LabelAnnotation,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            isSelected: false,
            isHovered: false
        }
    },
    
    computed: {
        annotationColor() {
            return this.annotation.color;
        },

        detailsText() {
            return reportUtils.getAnnotationDetailsText(this.annotation);
        },

        isReadOnly() {
            return !this.annotation.id || !this.annotation.id.startsWith('tool_');
        }
    },

    methods: {
        onClick() {
            if (this.isReadOnly || this.disabled)
                return;
            this.isSelected = !this.isSelected;
            evtBus.$emit('evt_annotationItem_select', { annotationId : this.annotation.id });
        },

        onMouseEnter() {
            if (this.isReadOnly || this.disabled)
                return;
            this.isHovered = true;
            evtBus.$emit('evt_annotationItem_focus', { annotationId : this.annotation.id });
            evtBus.$emit('evt_annotationItem_onFocus', { annotationId : this.annotation.id });
        },

        onMouseLeave() {
            if (this.isReadOnly || this.disabled)
                return;
            this.isHovered = false;
            evtBus.$emit('evt_annotationItem_blur', { annotationId : this.annotation.id });
        }
    },

    mounted() {
        evtBus.$on('evt_annotationItem_onSelect', (payload) => {
            if (this.disabled)
                return;
            this.isSelected = payload.annotationId == this.annotation.id;
        });

        evtBus.$on('evt_annotationItem_onFocus', (payload) => {
            if (this.disabled)
                return;
            this.isHovered = payload.annotationId == this.annotation.id;
        });

    }
}
</script>
<style scoped>
@import '../../styles/label_annotations.css';
</style>